import React, { useState } from 'react'
import { NavBar } from '../NavBar'
import { Bars, Cancel, RowHeader, ColOptions, ColLogo, ColSocialNetworks, LogoHeader } from './styles';
import { HeaderLink } from './styles';
import { FacebookIcon } from '../Icons/FacebookIcon'
import { InstagramIcon } from '../Icons/InstagramIcon';
import { WhatssapIcon } from '../Icons/WhatssapIcon';
import { Link } from '@reach/router'


export const Header = () => {
    
    const [open, setOpen] = useState(false);
    const handleClick = () => setOpen(!open);
    const Icon = open ? Cancel : Bars;

    return (
        <RowHeader>     
            <ColSocialNetworks xs={{ span: 8, order: 2 }} md={{ span: 3, order: 1 }} >
                {/* <HeaderLink href="https://web.whatsapp.com/send?text=Hola%2C%20me%20interesar%C3%ADa%20saber%20m%C3%A1s%20sobre&phone=573218068913"><WhatssapIcon fill={'#C24728'} fillOver={'#F9BE84'} width={'30px'} height={'100%'} /></HeaderLink> */}
                <HeaderLink href="https://wa.me/573218068913?text=Hola%2C%20me%20interesar%C3%ADa%20saber%20m%C3%A1s%20sobre%20el%20producto"><WhatssapIcon fill={'#C24728'} fillOver={'#F9BE84'} width={'30px'} height={'100%'} /></HeaderLink>
                <HeaderLink href="https://www.facebook.com/profile.php?id=100081301421482"><FacebookIcon fill={'#C24728'} fillOver={'#F9BE84'} width={'30px'} height={'100%'} /></HeaderLink>
                <HeaderLink href="https://www.instagram.com/koracosmetics1"><InstagramIcon fill={'#C24728'} fillOver={'#F9BE84'} width={'30px'} height={'100%'} /></HeaderLink>
            </ColSocialNetworks>
            <ColOptions xs={{ span: 0 }} md={{ span: 18, order: 2 }} >
                <NavBar open={open} click={handleClick}/>
            </ColOptions>
            <ColLogo xs={{ span: 8 , order: 3}} md={{ span: 3, order: 3 }} >
                <Link to='/'><LogoHeader/></Link>
            </ColLogo>
            <ColOptions xs={{ span: 8 , order: 1}} md={{ span: 0, order: 3 }} >
                <Icon onClick={handleClick} />
                <NavBar open={open} click={handleClick}/>
            </ColOptions>
        </RowHeader>
    )
}

